import React from 'react';
import { useController } from 'react-hook-form';
import styled from 'styled-components';
import { ErrorMessage, useScreenQuery } from 'playup-web-core';

const ControlledInput = ({ name, label, className, ...props }: ControlledInputProps) => {
	const {
		field,
		fieldState: { error },
	} = useController({
		name,
	});
	const { isSmall } = useScreenQuery();

	return (
		<Container className={className}>
			<LabelWrapper isSmallScreen={isSmall}>
				{label && typeof label === 'string' ? <label>{label}</label> : label}
			</LabelWrapper>
			<InputWrapper>
				<TextInput
					buttonPadding={0}
					isSmallScreen={isSmall}
					error={!!error}
					{...props}
					value={field.value}
					onChange={field.onChange}
					onBlur={field.onBlur}
					ref={field.ref}
				/>
			</InputWrapper>
			{error?.message && <ErrorMessage textAlign="left">{error?.message}</ErrorMessage>}
		</Container>
	);
};
type TextInputProps = Omit<
	React.InputHTMLAttributes<HTMLInputElement>,
	'onChange' | 'onBlur' | 'ref' | 'value' | 'error' | 'defaultValue'
>;
interface ControlledInputProps extends TextInputProps {
	name: string;
	label?: React.ReactElement | string;
}
export default ControlledInput;

const Container = styled.div({
	flexDirection: 'column',
	flex: 1,
});

//From web-core TextInput and should remain the same
const LabelWrapper = styled.div<{ isSmallScreen?: boolean }>`
	display: flex;
	justify-content: space-between;

	label {
		font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '16px')};
		margin-bottom: ${({ isSmallScreen }) => (isSmallScreen ? '5px' : '7px')};
		display: block;
		color: ${({ theme }) => theme.colors.darkR};
		user-select: none;
	}
`;
//From web-core TextInput and should remain the same
export const TextInput = styled.input<{
	isSmallScreen?: boolean;
	error?: boolean;
	buttonPadding?: React.CSSProperties['padding'];
	darkMode?: boolean;
}>`
	display: block;
	position: relative;
	width: 100%;
	height: ${({ isSmallScreen }) => (isSmallScreen ? '40px' : '50px')};
	padding: ${({ isSmallScreen }) => (isSmallScreen ? '10px' : '10px 18px')};
	padding-right: calc(${({ buttonPadding }) => buttonPadding} + 0.5rem);
	border-radius: 4px;
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
	color: ${({ darkMode }) => (darkMode ? '#fff' : '#2D3134')};
	background-color: ${({ darkMode }) => (darkMode ? '#2D3134' : '#fff')};
	font-family: Barlow, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
		'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
	text-align: left;
	border: 2px solid ${({ theme, error, darkMode }) => (error ? theme.colors.danger : darkMode ? '#2D3134' : '#DDE1E3')};

	&:focus {
		outline: none;
	}

	::placeholder {
		color: ${({ darkMode }) => (darkMode ? '#fff' : '#a4a6a8')};
	}
`;
//From web-core TextInput and should remain the same
const InputWrapper = styled.div`
	position: relative;
`;
